<template>
  <div class="flex flex-col gap-7">
    <SizeSelect show-pricing>
      <template #pricing="{ size }">
        for {{ formatMoney(store.priceForSize(size)) }}
      </template>
    </SizeSelect>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useBundleStore } from '@/stores'
import { formatMoney } from '@/utils'
import SizeSelect from '@/components/bundle/size-select.vue'

const store = useBundleStore()
onMounted(() => {
  store.plan = 'onetime'
  store.onetimeOnly = true
})
</script>
